import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
    NoDeliveryReasonModel,
    PaymentMethodModel,
    PreorderedProductModel,
    PriceListModel,
    ProductModel,
    ReturnReasonModel,
    RouteModel,
} from '@app/models';

interface RouteDataModel
{
    route: RouteModel;
    products: ProductModel[];
    price_lists: PriceListModel[];
    preordered_items: PreorderedProductModel[];
    payment_methods: PaymentMethodModel[];
    no_delivery_reasons: NoDeliveryReasonModel[];
    return_reasons: ReturnReasonModel[];
    power_of_one_stores: string[];
}

@Injectable({
    providedIn: 'root',
})
export class RouteService
{
    private endPoint = '/routes';
    private http = inject(HttpClient);

    getTodayRoutes(): Promise<RouteModel[]>
    {
        const url = `${this.endPoint}/getTodayRoutes`;

        return firstValueFrom(this.http.get<RouteModel[]>(url));
    }

    startRoute(id: number): Promise<boolean>
    {
        const url = `${this.endPoint}/${id}/startRoute`;

        return firstValueFrom(this.http.get<boolean>(url));
    }

    getRouteData(id: number): Promise<RouteDataModel>
    {
        const url = `${this.endPoint}/${id}/data`;

        return firstValueFrom(this.http.get<RouteDataModel>(url));
    }
}
